import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import LoginPage from './pages/LoginPage'
import Dashboard from './pages/Dashboard'
import ShopifyPage from './pages/ShopifyPage'
import MoloniPage from './pages/MoloniPage'
import BatchPage from './pages/BatchPage'
import DPDPage from './pages/DPDPage'
import CTTPage from './pages/CTTPage'
import DHLPage from './pages/DHLPage'
import MRWPage from './pages/MRWPage'
import AffiliatlyPage from './pages/AffiliatlyPage'
import InstagramPage from './pages/InstagramPage'
import TikTokPage from './pages/TikTokPage'
import ApplicationsPage from './pages/ApplicationsPage'
import StoreVilaNovaGaiaPage from './pages/StoreVilaNovaGaiaPage'
import StoreColomboPage from './pages/StoreColomboPage'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/shopify" element={<ShopifyPage />} />
                    <Route path="/moloni" element={<MoloniPage />} />
                    <Route path="/batch" element={<BatchPage />} />
                    <Route path="/affiliatly" element={<AffiliatlyPage />} />
                    <Route path="/instagram" element={<InstagramPage />} />
                    <Route path="/tiktok" element={<TikTokPage />} />
                    <Route path="/applications" element={<ApplicationsPage />} />
                    <Route path="/store-vila-nova-gaia" element={<StoreVilaNovaGaiaPage />} />
                    <Route path="/store-colombo" element={<StoreColomboPage />} />
                    <Route path="/dpd" element={<DPDPage />} />
                    <Route path="/ctt" element={<CTTPage />} />
                    <Route path="/dhl" element={<DHLPage />} />
                    <Route path="/mrw" element={<MRWPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
